import { HostsTable } from "@/admin/hosts/HostsTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/hosts")({
    component: HostsTable,
});
